(function () {
  // Shopify's deferred API helper may replace the layout's fallback formatter.
  // Retain the actual Markets currency before product-ready callbacks execute.
  if (window.Shopify && window.theme && theme.formatPresentmentMoney && window.shopCurrency !== theme.shop_currency) {
    Shopify.formatMoney = theme.formatPresentmentMoney;
  }
  console.log('[cart-drawer] script loaded');

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) {
    console.log('[cart-drawer] no #cart-drawer element found');
    return;
  }

 var drawerBody = drawer.querySelector('[data-cart-drawer-body]');
var drawerFooter = drawer.querySelector('[data-cart-drawer-footer]');
var headerCartCountEls = document.querySelectorAll('.cart-link .number[data-cart-count]');
var drawerCartCountEl = drawer.querySelector('[data-cart-count]');
var cartCountWrapperEls = document.querySelectorAll('.cart-link .number-wrapper');
var toggleButtons = document.querySelectorAll('[data-cart-toggle="cart-drawer"]');
var closeTriggers = drawer.querySelectorAll('[data-cart-close], [data-keep-shopping]');
var FREE_SHIPPING_THRESHOLD_CENTS = 7500;
var refreshSequence = 0;
var SHOPIFY_FORMS_TEASER_SELECTOR = 'shopify-forms-embed, [id*="shopify-forms"], [class*="shopify-forms"], iframe[src*="shopify"][src*="form"], iframe[title*="25%"], iframe[aria-label*="25%"]';

  var teaserObserver = null;
  var suppressedTeaserEls = [];

  function isDiscountTeaser(el) {
    if (!el || !el.getAttribute || drawer.contains(el)) return false;

    if (el.matches && el.matches(SHOPIFY_FORMS_TEASER_SELECTOR)) return true;

    var haystack = [
      el.getAttribute('aria-label'),
      el.getAttribute('title'),
      el.getAttribute('name'),
      el.id,
      el.className && typeof el.className === 'string' ? el.className : '',
      el.textContent
    ].filter(Boolean).join(' ').toLowerCase();

    return /get\s+(up\s+to\s+)?25%\s+off/.test(haystack) ||
      /up\s+to\s+25%\s+off/.test(haystack) ||
      (/25%\s+off/.test(haystack) && /teaser|popup|pop[- ]?up|shopify|newsletter|email|discount/.test(haystack));
  }

  function getTeaserContainer(el) {
    var current = el;

    while (current && current !== document.body && current.parentElement) {
      var style = window.getComputedStyle(current);
      var rect = current.getBoundingClientRect();

      if ((style.position === 'fixed' || style.position === 'sticky') && rect.width > 0 && rect.height > 0) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  function suppressDiscountTeasers() {
    var candidates = document.querySelectorAll(SHOPIFY_FORMS_TEASER_SELECTOR + ', iframe, [aria-label], [title], button, a, div, aside, section');

    candidates.forEach(function (candidate) {
      if (!isDiscountTeaser(candidate)) return;

      var target = getTeaserContainer(candidate);
      if (!target || drawer.contains(target) || target.hasAttribute('data-cart-drawer-suppressed-teaser')) return;

      target.setAttribute('data-cart-drawer-suppressed-teaser', 'true');
      target.setAttribute('data-cart-drawer-previous-display', target.style.display || '');
      target.style.display = 'none';
      suppressedTeaserEls.push(target);
    });
  }

  function startSuppressingDiscountTeasers() {
    suppressDiscountTeasers();

    if (!teaserObserver) {
      teaserObserver = new MutationObserver(function () {
        suppressDiscountTeasers();
      });
    }

    teaserObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title', 'class', 'style']
    });
  }

  function restoreDiscountTeasers() {
    if (teaserObserver) {
      teaserObserver.disconnect();
    }

    suppressedTeaserEls.forEach(function (el) {
      if (!el || !el.hasAttribute('data-cart-drawer-suppressed-teaser')) return;

      el.style.display = el.getAttribute('data-cart-drawer-previous-display') || '';
      el.removeAttribute('data-cart-drawer-suppressed-teaser');
      el.removeAttribute('data-cart-drawer-previous-display');
    });

    suppressedTeaserEls = [];
  }

  var teaserObserver = null;
  var suppressedTeaserEls = [];

  function isDiscountTeaser(el) {
    if (!el || !el.getAttribute || drawer.contains(el)) return false;

    var haystack = [
      el.getAttribute('aria-label'),
      el.getAttribute('title'),
      el.getAttribute('name'),
      el.id,
      el.className && typeof el.className === 'string' ? el.className : '',
      el.textContent
    ].filter(Boolean).join(' ').toLowerCase();

    return /get\s+(up\s+to\s+)?25%\s+off/.test(haystack) ||
      /up\s+to\s+25%\s+off/.test(haystack) ||
      (/25%\s+off/.test(haystack) && /teaser|popup|pop[- ]?up|shopify|newsletter|email|discount/.test(haystack));
  }

  function getTeaserContainer(el) {
    var current = el;

    while (current && current !== document.body && current.parentElement) {
      var style = window.getComputedStyle(current);
      var rect = current.getBoundingClientRect();

      if ((style.position === 'fixed' || style.position === 'sticky') && rect.width > 0 && rect.height > 0) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  function suppressDiscountTeasers() {
    var candidates = document.querySelectorAll('iframe, [aria-label], [title], button, a, div, aside, section');

    candidates.forEach(function (candidate) {
      if (!isDiscountTeaser(candidate)) return;

      var target = getTeaserContainer(candidate);
      if (!target || drawer.contains(target) || target.hasAttribute('data-cart-drawer-suppressed-teaser')) return;

      target.setAttribute('data-cart-drawer-suppressed-teaser', 'true');
      target.setAttribute('data-cart-drawer-previous-display', target.style.display || '');
      target.style.display = 'none';
      suppressedTeaserEls.push(target);
    });
  }

  function startSuppressingDiscountTeasers() {
    suppressDiscountTeasers();

    if (!teaserObserver) {
      teaserObserver = new MutationObserver(function () {
        suppressDiscountTeasers();
      });
    }

    teaserObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title', 'class', 'style']
    });
  }

  function restoreDiscountTeasers() {
    if (teaserObserver) {
      teaserObserver.disconnect();
    }

    suppressedTeaserEls.forEach(function (el) {
      if (!el || !el.hasAttribute('data-cart-drawer-suppressed-teaser')) return;

      el.style.display = el.getAttribute('data-cart-drawer-previous-display') || '';
      el.removeAttribute('data-cart-drawer-suppressed-teaser');
      el.removeAttribute('data-cart-drawer-previous-display');
    });

    suppressedTeaserEls = [];
  }

  function formatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('Cart fetch failed');
      }
      return res.json();
    });
  }

  function updateFreeShippingBannerFromCart(cart) {
    var banner = drawer.querySelector('.cart-drawer__shipping[data-free-ship-banner="true"]');
    if (!banner || !cart) return;

    var threshold = parseInt(banner.getAttribute('data-free-ship-threshold'), 10) || FREE_SHIPPING_THRESHOLD_CENTS;
    var subtotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : (cart.total_price || 0);
    var remaining = threshold - subtotal;

    if (!cart.item_count) {
      banner.hidden = true;
      banner.setAttribute('hidden', 'hidden');
      return;
    }

    banner.hidden = false;
    banner.removeAttribute('hidden');

    if (remaining > 0) {
      banner.textContent = 'You\'re ' + formatMoney(remaining) + ' away from FREE shipping.';
    } else {
      banner.textContent = '✨ You\'ve unlocked FREE shipping!';
    }
  }

  console.log('[cart-drawer] toggleButtons found:', toggleButtons.length);
  console.log('[cart-drawer] closeTriggers found:', closeTriggers.length);

  // We support both the theme's "is-open" and our "cart-drawer--open" classes
  function openDrawer() {
    console.log('[cart-drawer] openDrawer()');
    drawer.classList.add('cart-drawer--open', 'is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll', 'cart-drawer-is-open');
    startSuppressingDiscountTeasers();
  }

  function closeDrawer() {
    console.log('[cart-drawer] closeDrawer()');
    drawer.classList.remove('cart-drawer--open', 'is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll', 'cart-drawer-is-open');
    restoreDiscountTeasers();
  }

  function syncFreeShippingBanner(newDrawer) {
    var currentBanner = drawer.querySelector('.cart-drawer__shipping[data-free-ship-banner="true"]');
    var newBanner = newDrawer ? newDrawer.querySelector('.cart-drawer__shipping[data-free-ship-banner="true"]') : null;

    if (!newBanner) {
      if (currentBanner) {
        currentBanner.hidden = true;
      }
      return;
    }

    if (!currentBanner) {
      var header = drawer.querySelector('.cart-drawer__header');
      if (header) {
        currentBanner = newBanner.cloneNode(true);
        header.insertAdjacentElement('afterend', currentBanner);
      }
      return;
    }

    currentBanner.innerHTML = newBanner.innerHTML;
    currentBanner.hidden = newBanner.hidden;
    if (newBanner.hasAttribute('hidden')) {
      currentBanner.setAttribute('hidden', 'hidden');
    } else {
      currentBanner.removeAttribute('hidden');
    }
  }

  function refreshDrawer() {
    var state = drawer.adoraCartState;
    if (state && state.busy) {
      return new Promise(function (resolve) {
        drawer.addEventListener('adora:cart-idle', function () {
          resolve(refreshDrawer());
        }, { once: true });
      });
    }
    var revision = state ? state.revision : 0;
    var sequence = ++refreshSequence;
    console.log('[cart-drawer] refreshDrawer()');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart?view=drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    })
      .then(function (res) {
        console.log('[cart-drawer] /cart?view=drawer status:', res.status);
        if (!res.ok) throw new Error('Cart drawer fetch failed');
        return res.text();
      })
      .then(function (html) {
        // The response describes the cart at request time, not completion time.
        // A discount/quantity/note action or a newer refresh owns the current UI.
        if (sequence !== refreshSequence || (state && (state.busy || state.revision !== revision))) return;
        var status = drawer.querySelector('[data-cart-status]');
        if (status) {
          status.textContent = '';
          status.hidden = true;
        }
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        var newDrawer = tempDiv.querySelector('#cart-drawer');
        if (!newDrawer) {
          throw new Error('Cart drawer missing from response');
        }

        var newBody = newDrawer.querySelector('[data-cart-drawer-body]');
        var newFooter = newDrawer.querySelector('[data-cart-drawer-footer]');
        var newCount = newDrawer.querySelector('[data-cart-count]');

        syncFreeShippingBanner(newDrawer);

        getCart()
          .then(updateFreeShippingBannerFromCart)
          .catch(function (err) {
            console.warn('[cart-drawer] free shipping banner update failed', err);
          });

        if (newBody && drawerBody) {
          drawerBody.innerHTML = newBody.innerHTML;
          console.log('[cart-drawer] drawer body updated');
        }

        if (drawerFooter) {
          if (newFooter) {
            drawerFooter.innerHTML = newFooter.innerHTML;
            drawerFooter.hidden = newFooter.hidden;
            if (newFooter.hasAttribute('hidden')) {
              drawerFooter.setAttribute('hidden', 'hidden');
            } else {
              drawerFooter.removeAttribute('hidden');
            }
            console.log('[cart-drawer] drawer footer updated');
          } else {
            drawerFooter.innerHTML = '';
            drawerFooter.hidden = true;
            drawerFooter.setAttribute('hidden', 'hidden');
            console.log('[cart-drawer] drawer footer cleared');
          }
        }

          if (newCount) {
            var count = parseInt(newCount.textContent, 10) || 0;

            // Update ALL header cart counts (desktop + mobile)
            headerCartCountEls.forEach(function (el) {
              el.textContent = count;
            });

            // Keep drawer's hidden count in sync
            if (drawerCartCountEl) {
              drawerCartCountEl.textContent = count;
            }

            // Show/hide the "(X)" wrapper(s) in all header cart links
            cartCountWrapperEls.forEach(function (wrapper) {
              if (count > 0) {
                wrapper.classList.remove('hide');
              } else {
                wrapper.classList.add('hide');
              }
            });

            console.log('[cart-drawer] cart count updated to', count);
}


      })
      .catch(function (err) {
        if (sequence !== refreshSequence || (state && (state.busy || state.revision !== revision))) return;
        console.error('[cart-drawer] refreshDrawer error', err);
        var status = drawer.querySelector('[data-cart-status]');
        if (status) {
          status.textContent = 'Could not refresh your cart. Reopen it to retry, or view your full cart.';
          status.hidden = false;
        }
      });
  }

  // Header Cart(X) -> refresh + open drawer
  toggleButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('[cart-drawer] Cart(X) clicked');
      refreshDrawer().then(openDrawer);
    });
  });

  // Close drawer on overlay or close button
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close], [data-keep-shopping]')) {
      e.preventDefault();
      console.log('[cart-drawer] close trigger clicked');
      closeDrawer();
    }
  });

  // Close on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      if (drawer.classList.contains('cart-drawer--open') || drawer.classList.contains('is-open')) {
        console.log('[cart-drawer] ESC pressed, closing drawer');
        closeDrawer();
      }
    }
  });

  // Keep Shopify/theme add-to-cart handling intact for analytics.
  // The theme submits product forms with jQuery to /cart/add.js; after that
  // confirmed successful response, refresh and open the drawer without sending
  // a second cart request or blocking the original product-form lifecycle.
  if (window.jQuery) {
    window.jQuery(function ($) {
      var cart = window.theme && theme.partials && theme.partials.cart;
      if (!cart || !cart.addToCart || cart.adoraAddGuard) return;
      cart.adoraAddGuard = true;
      var add = cart.addToCart;
      cart.addToCart = function (form) {
        if (form.data('adora-add-pending')) return;
        form.data('adora-add-pending', true);
        var buttons = form.find('[type="submit"]:enabled');
        buttons.prop('disabled', true).attr('aria-busy', 'true');
        var status = form.find('[data-cart-add-status]');
        if (!status.length) status = $('<p data-cart-add-status role="status" aria-live="polite"></p>').appendTo(form);
        status.text('Adding to cart...');
        function release() {
          form.removeData('adora-add-pending');
          buttons.prop('disabled', false).attr('aria-busy', 'false');
        }
        try {
          // Retain the original request and analytics lifecycle; never retry a POST.
          return add.call(cart, form).done(function () {
            status.text('Added to cart.');
          }).fail(function () {
            status.text('Could not confirm the add. Check your cart before trying again.');
          }).always(release);
        } catch (err) {
          release();
          status.text('Could not confirm the add. Check your cart before trying again.');
          throw err;
        }
      };
    });
    window.jQuery(document).on('ajaxSuccess.cartDrawer', function (_event, _xhr, settings) {
      var url = settings && settings.url ? settings.url : '';
      if (url.indexOf('/cart/add') === -1) return;

      console.log('[cart-drawer] observed successful add-to-cart request:', url);

      refreshDrawer()
        .then(function () {
          openDrawer();
        })
        .catch(function (err) {
          console.error('[cart-drawer] refresh after add error', err);
        });
    });
  }
})();

